module.exports = __webpack_public_path__ + "media/images/upload-cover-c0d3ce2d769b74cdc1e750953a4b3226.png";